import { render } from "./TimerComponent.vue?vue&type=template&id=4506df78&scoped=true"
import script from "./TimerComponent.vue?vue&type=script&lang=js"
export * from "./TimerComponent.vue?vue&type=script&lang=js"

import "./TimerComponent.vue?vue&type=style&index=0&id=4506df78&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\timer-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4506df78"]])

export default __exports__